module.exports = __webpack_public_path__ + "static/indirimdekiler-3-9a18d944f5c21ccb7f77989d1b2aad57.jpg";